import React from 'react';
import { Box, Container, Divider, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        backgroundColor: (theme) => theme.palette.grey[100],
        width: '100%' // Volle Breite des Containers
      }}
    >
      <Container maxWidth={false}> {/* Breiter Container für bessere Anpassung */}
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ 
          display: 'flex',
          justifyContent: 'center', 
          flexWrap: 'wrap', 
          gap: 2 
        }}>

        
          {/* Externer Link zum Impressum - öffnet in neuem Tab */}
          <Link 
            href="https://trampolin-tbruit.de/impressum" 
            color="inherit" 
            underline="hover"
            target="_blank"  // Öffnet in neuem Tab
            rel="noopener"   // Sicherheitsmaßnahme für externe Links
          >
            Impressum
          </Link>
          
          {/* Externer Link zur Datenschutzerklärung - öffnet in neuem Tab */}
          <Link 
            href="https://trampolin-tbruit.de/datenschutz" 
            color="inherit" 
            underline="hover"
            target="_blank"  // Öffnet in neuem Tab
            rel="noopener"   // Sicherheitsmaßnahme für externe Links
          >
            Datenschutz
          </Link>
          
          {/*
          <Link component={RouterLink} to="/impressum" color="inherit" underline="hover">
            Impressum
          </Link>
          <Link component={RouterLink} to="/datenschutz" color="inherit" underline="hover">
            Datenschutz
          </Link>*/}
        </Box>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
          © {new Date().getFullYear()} Turnerbund Ruit 1892 e.V. Alle Rechte vorbehalten.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;